import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import {CreateEditFormBase} from '../components/CreateEditFormBase'
import './CreateEdit.css';

import { withFirebase } from '../firebase';
import { AuthUserContext, withAuthorization } from '../session';


class Edit extends Component {

  render() {
    let sona_id = this.props.match.params.sona_id
    return (
      <AuthUserContext.Consumer>
        {(ctx) => {
          return (
            <div>
              <img
                className="Create-logo"
                src={process.env.PUBLIC_URL + '/img/logo.png'}
                alt="logo"
              />
              <h1 className="Create-title">Edit SONA</h1>
              <EditForm edit_sona_id={sona_id} user={ctx.authUser} admin={ctx.admin} />
            </div>
          )
        }}
      </AuthUserContext.Consumer>
      )

  }
}


const EditForm = compose(
  withRouter,
  withFirebase
)(CreateEditFormBase);

const condition = authUser => !!authUser;
export default withAuthorization(condition)(Edit);

export { EditForm };
